import * as React from "react";

export const AlertIconOrange = (props: any) => (
  <svg
    width={22}
    height={19}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 3.99 18.53 17H3.47L11 3.99ZM11 0 0 19h22L11 0Zm1 14h-2v2h2v-2Zm0-6h-2v4h2V8Z"
      fill="#ED6C02"
    />
  </svg>
);
